import UserService from './user.service';

let upcomingMeetingsCache = null;

export function isMeetingsRoute(route) {
  if (!route) return false;
  const name = route.name || '';
  const path = route.path || '';
  return name === 'Meetings' || path === '/meetings' || path.startsWith('/meetings');
}

/** Fetch upcoming-meetings flag — call only from the Meetings tab. */
export async function fetchUpcomingMeetingsIndicator() {
  const response = await UserService.authPostRequest('get-meetings', { type: 'Upcoming' });
  if (response?.data?.status !== 'success') {
    upcomingMeetingsCache = false;
    return false;
  }
  const list = (response.data.data && response.data.data.list) || [];
  upcomingMeetingsCache = Array.isArray(list) && list.length > 0;
  return upcomingMeetingsCache;
}

export function getCachedUpcomingMeetingsIndicator() {
  return upcomingMeetingsCache;
}

export function clearUpcomingMeetingsCache() {
  upcomingMeetingsCache = null;
}
